import { FC, HTMLAttributeAnchorTarget, ReactNode } from "react";
import clsx from "clsx";

import { StyledLink } from "styles/components/link";

interface LinkProps {
  route: string;
  children: ReactNode;
  size?: "sm";
  className?: string;
  dataTestId?: string;
  target?: HTMLAttributeAnchorTarget;
}

const Link: FC<LinkProps> = ({
  route,
  children,
  size,
  target,
  className,
  dataTestId,
}) => {
  const linkClassName = clsx(["link", { link_sm: size === "sm" }, className]);

  return (
    <StyledLink
      to={route}
      target={target}
      rel="noopener noreferrer"
      className={linkClassName}
      data-testid={dataTestId}
    >
      {children}
    </StyledLink>
  );
};

export default Link;
